export const getUrlWithProtocol = (url) => (url.startsWith('http') ? url : `https://${url}`);
